"use client";

import { AuthProvider } from "@/Components/AuthContext/AuthContext";

export function Providers({ children }: { children: React.ReactNode }) {
  return <AuthProvider>{children}</AuthProvider>;
}
